import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { AngularFire } from "angularfire2";
import { UiService } from "../../providers/ui";
import { PostService } from "../../providers/post";
import { CommentService } from "../../providers/comment";
import { UserService } from "../../providers/user";
import { User } from "../user/user";

@Component({
  selector: "page-post",
  templateUrl: "post.html",
})
export class Post {
  loader: any = null;
  postModel: any = {};
  postList: string;
  postSubscription: any;
  comments: any = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public postService: PostService,
    public commentService: CommentService,
    public uiService: UiService,
    public userService: UserService,
    public af: AngularFire,
  ) {
    this.postModel = navParams.get("postModel");
    this.postList = navParams.get("postList");
    if (this.postModel && this.postList) {
      this.postSubscription = this.af.database
        .object(`${this.postList}/${this.postModel.id}`)
        .subscribe((post: any) => {
          this.postModel = post;
        });

      this.af.database
        .list(`comments/${this.postModel.id}`)
        .subscribe(rooms => {
          this.comments = [];
          rooms.map(item => {
            let tmpObj: any = {};
            this.af.database
              .list(`comments/${this.postModel.id}/${item.$key}`)
              .take(1)
              .subscribe((data: any) => {
                tmpObj.title = data[0].title;
                tmpObj.comments = data;
                this.comments.push(tmpObj);
              });
          });
        });
    }
  }

  ionViewDidEnter() {
    return this.postService
      .updateReadStatus(true, this.postModel)
      .then(post => {
        this.postModel = post;
      });
  }

  ionViewWillLeave() {
    this.postSubscription.unsubscribe();
  }

  // Event handlers
  onMarkAsRead() {
    return this.onUpdatePostReadStatus(true);
  }

  onMarkAsNotRead() {
    return this.onUpdatePostReadStatus();
  }

  onUpdatePostReadStatus(read: boolean = false) {
    return this.postService
      .updateReadStatus(read, this.postModel)
      .then(() => {
        return this.uiService.showToast(
          `Post has been marked as "${read ? "" : "not "}read"`,
        );
      })
      .catch(error => {
        return this.uiService.showToast(`Error: ${error.message}`);
      });
  }

  onMarkAsModerated() {
    return this.onUpdatePostModeratedStatus(true);
  }

  onMarkAsNotModerated() {
    return this.onUpdatePostModeratedStatus();
  }

  onUpdatePostModeratedStatus(moderated: boolean = false) {
    return this.postService
      .updateModeratedStatus(moderated, this.postModel)
      .then(() => {
        return this.uiService.showToast(
          `Post has been marked as "${moderated ? "" : "not "}moderated"`,
        );
      })
      .catch(error => {
        return this.uiService.showToast(`Error: ${error.message}`);
      });
  }

  onUpdateCommentModeratedStatus(comment: any, post: any, moderated: boolean) {
    return this.commentService
      .updateModeratedStatus(comment, post, moderated)
      .then(() => {
        return this.uiService.showToast(
          `Post has been marked as "${moderated ? "" : "not "}moderated"`,
        );
      })
      .catch(error => {
        return this.uiService.showToast(`Error: ${error.message}`);
      });
  }

  onMarkAsBlocked() {
    return this.onUpdatePostBlockedStatus(true);
  }

  onMarkAsNotBlocked() {
    return this.onUpdatePostBlockedStatus();
  }

  onUpdatePostBlockedStatus(blocked: boolean = false) {
    return this.postService
      .updateBlockedStatus(blocked, this.postModel)
      .then(() => {
        return this.uiService.showToast(
          `Post has been marked as "${blocked ? "" : "not "}blocked"`,
        );
      })
      .catch(error => {
        return this.uiService.showToast(`Error: ${error.message}`);
      });
  }

  onUpdateCommentBlockedStatus(comment: any, post: any, blocked: boolean) {
    return this.commentService
      .updateBlockedStatus(comment, post, blocked)
      .then(() => {
        return this.uiService.showToast(
          `Post has been marked as "${blocked ? "" : "not "}blocked"`,
        );
      })
      .catch(error => {
        return this.uiService.showToast(`Error: ${error.message}`);
      });
  }

  onDelete() {
    if (!confirm("Are you sure you want to delete this post?")) {
      return;
    }

    return this.postService
      .deletePost(this.postModel)
      .then(() => {
        return this.navCtrl.pop();
      })
      .then(() => {
        return this.uiService.showToast("The post has been deleted.");
      })
      .catch(error => {
        return this.uiService.showToast(`Error: ${error.message}`);
      });
  }

  onViewUser() {
    return this.userService
      .getUserById(this.postModel.userId)
      .then((user: any) => {
        if (!user) {
          return this.uiService.showAlert(
            "Whoops!",
            "Could not fetch user details for post author, please try again.",
          );
        }

        return this.navCtrl.push(User, {
          user: user,
        });
      });
  }

  isBlocked(model) {
    return model.blocked === PostService.postBlockStateBlocked;
  }

  isNotBlocked(model) {
    return model.blocked !== PostService.postBlockStateBlocked;
  }

  isModerated(model) {
    return model.moderated === PostService.postModerateStateModerated;
  }

  isNotModerated(model) {
    return model.moderated !== PostService.postModerateStateModerated;
  }

  get postIsRead() {
    return this.postModel.markedAsRead === PostService.postReadStateRead;
  }

  get postIsNotRead() {
    return (
      !this.postModel.markedAsRead ||
      this.postModel.markedAsRead === PostService.postReadStateNotRead
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/post/post.ts